import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
//import timezone from 'dayjs/plugin/timezone'
import localeFr from 'dayjs/locale/fr'

dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(utc)
//dayjs.extend(timezone)
// Railway industry convention: the week containing January 1st is always week 1.
// yearStart: 1 means a week belongs to a year if it has at least 1 day in that year,
// instead of ISO 8601's yearStart: 4 (at least 4 days, i.e. containing the first Thursday).
dayjs.locale({...localeFr, yearStart: 1} as typeof localeFr & {
  yearStart: number
})

export default dayjs
